import type { GetTeamsQuery, GetTeamsResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_TEAMS_LIMIT = 50

function getTeams(query: GetTeamsQuery): Promise<GetTeamsResponse> {
  return requestApiJsonOrThrow<GetTeamsResponse>('admin/teams', {
    params: query,
  })
}

export const teamsQuery = (queryParams: GetTeamsQuery) => ({
  queryKey: ['teams', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getTeams({
      limit: GET_TEAMS_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetTeamsResponse, pages: GetTeamsResponse[]) => {
    if (lastPage.data.length < GET_TEAMS_LIMIT) return
    return pages.length * GET_TEAMS_LIMIT
  },
})
